// generated by docker build
export const appConfig = {    
  editorBucketNameParameterPath: "/prod/architect-io/bucket/editor",
  reviewerBucketNameParameterPath: "/prod/architect-io/bucket/reviewer",
  publishedBucketNameParameterPath: "/prod/architect-io/bucket/published",
  publishToReviewLambdaParameterPath: "/prod/architect-io/lambda/publish-to-review",
  publishLambdaParameterPath: "/prod/architect-io/lambda/publish",
}
